<template>
  <section>
    <div class="row justify-content-center">
      <template v-for="leilao in getLeiloesListados">
        <leilao-card v-if="!leilao.parceiro" :key="leilao.id" classeRaiz="col-10 col-sm-10 col-md-6 col-lg-3"
          :leilao="leilao.item" />
        <leilao-parceiro-card v-else :key="leilao.id" classeRaiz="col-10 col-sm-10 col-md-6 col-lg-3"
          :leilao="leilao.item" />
      </template>
      <div class="col-12 text-center my-5"
        v-if="!getLeiloesBreveLoading && getLeiloesBreve && getLeiloesBreve.length == 0">
        <h6 class="text-muted">NÃO HÁ LEILÕES AGENDADOS NO MOMENTO</h6>
      </div>
    </div>
    <div class="center d-flex">
      <h4 class="title mb-5 mt-5 verTodos text-center" v-if="getLeiloesBreveLoading">CARREGANDO...</h4>
    </div>
    <div class="center d-flex" v-if="getIsNextPage">
      <h4 class="title mb-5 mt-5 verTodos" @click="carregarMaisLeiloes" v-if="!getLeiloesBreveLoading">CARREGAR MAIS
        LEILÕES
      </h4>
    </div>
  </section>
</template>

<script>
import LeilaoCard from '@/components/LeilaoCard.vue';
import LeilaoParceiroCard from '@/components/LeilaoParceiroCard.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
  components: {
    LeilaoCard,
    LeilaoParceiroCard
  },
  data() {
    return {
      pageNumber: 0
    };
  },
  watch: {
    pageNumber(value, oldvalue) {
      if (value == oldvalue) return;

      this.setLeiloesPorStatus({
        pageSize: 4,
        pageNumber: this.pageNumber,
        status: 'breve'
      });
    }
  },
  computed: {
    ...mapGetters(['getLeiloesBreve', 'getLeiloesBreveLoading', 'getIsNextPage', 'getLeiloesParceiro']),
    getLeiloesListados() {
      const lista = [];
      if (this.getLeiloesBreve && this.getLeiloesBreve.length) {
        this.getLeiloesBreve.forEach((item) => lista.push({ id: item.id, parceiro: false, item }));
      }
      if (this.getLeiloesParceiro && this.getLeiloesParceiro.data) {
        this.getLeiloesParceiro.data.forEach((item) => {
          if (
            item.status?.toLowerCase() != 'encerrado' &&
            item.status?.toLowerCase() != 'cancelado' &&
            item.status?.toLowerCase() != 'suspenso' &&
            item.status?.toLowerCase() != 'em pregão' &&
            item.status?.toLowerCase() != 'aberto'
          ) {
            lista.push({ id: item.leilaoParceiroId, parceiro: true, item });
          }
        });
      }
      return lista.sort((a, b) => new Date(a.item.dataLeilao || a.item.pracas?.[0] || 0) - new Date(b.item.dataLeilao || b.item.pracas?.[0] || 0));
    }
  },
  methods: {
    ...mapActions(['setLeiloesPorStatus']),
    ...mapMutations(['SET_LEILOES_BREVE', 'IS_NEXT_PAGE']),
    carregarMaisLeiloes() {
      this.pageNumber++;
    }
  },
  async created() {
    this.pageNumber++;
  },
  destroyed() {
    this.SET_LEILOES_BREVE();
    this.IS_NEXT_PAGE();
  }
};
</script>
